var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.93 1.853a1.062 1.062 0 0 0-1.822-.002L1.503 13.128a1.01 1.01 0 0 0-.139.51c0 .568.47 1.027 1.05 1.027h13.172c.182 0 .361-.046.52-.134.503-.281.679-.908.392-1.4L9.93 1.852zm.288-1.54c.374.21.684.513.897.88l6.568 11.277a2.334 2.334 0 0 1-.902 3.22c-.364.203-.776.31-1.195.31H2.413C1.081 16 0 14.943 0 13.639c0-.412.11-.817.32-1.174L6.923 1.188C7.587.056 9.062-.335 10.218.313zm-1.22 11.272a.934.934 0 0 0-.945.924c0 .51.423.924.944.924a.934.934 0 0 0 .945-.924.934.934 0 0 0-.945-.924zm0-7.186a.735.735 0 0 0-.735.734v4.691a.735.735 0 1 0 1.469 0v-4.69a.735.735 0 0 0-.735-.735z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.9f1d7f0b.svg";
export { ForwardRef as ReactComponent };